/* tslint:disable */
/* eslint-disable */
/**
 * Appli métier
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: Yoda 1 & 2
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { Configuration } from "../configuration"
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from "axios"
import globalAxios from "axios"
// Some imports not used depending on template conditions
// @ts-ignore
import {
  DUMMY_BASE_URL,
  assertParamExists,
  setApiKeyToObject,
  setBasicAuthToObject,
  setBearerAuthToObject,
  setOAuthToObject,
  setSearchParams,
  serializeDataIfNeeded,
  toPathString,
  createRequestFunction,
  replaceWithSerializableTypeIfNeeded
} from "../common"
// @ts-ignore
import {
  BASE_PATH,
  COLLECTION_FORMATS,
  type RequestArgs,
  BaseAPI,
  RequiredError,
  operationServerMap
} from "../base"
// @ts-ignore
import type { Entrepreneur } from "../model"
/**
 * EntrepreneurResourceV2Api - axios parameter creator
 */
export const EntrepreneurResourceV2ApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     *
     * @summary Get entrepreneurs by note id
     * @param {string} noteId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getEntrepreneursByNoteId: async (
      noteId: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'noteId' is not null or undefined
      assertParamExists("getEntrepreneursByNoteId", "noteId", noteId)
      const localVarPath = `/v2.0/entrepreneurs/projects/{noteId}`.replace(
        "{noteId}",
        encodeURIComponent(String(noteId))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "GET", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication oauth2 required
      // oauth required
      await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)

      localVarHeaderParameter["Accept"] = "application/json"

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    }
  }
}

/**
 * EntrepreneurResourceV2Api - functional programming interface
 */
export const EntrepreneurResourceV2ApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = EntrepreneurResourceV2ApiAxiosParamCreator(configuration)
  return {
    /**
     *
     * @summary Get entrepreneurs by note id
     * @param {string} noteId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getEntrepreneursByNoteId(
      noteId: string,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Entrepreneur>>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.getEntrepreneursByNoteId(
        noteId,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["EntrepreneurResourceV2Api.getEntrepreneursByNoteId"]?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    }
  }
}

/**
 * EntrepreneurResourceV2Api - factory interface
 */
export const EntrepreneurResourceV2ApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  const localVarFp = EntrepreneurResourceV2ApiFp(configuration)
  return {
    /**
     *
     * @summary Get entrepreneurs by note id
     * @param {EntrepreneurResourceV2ApiGetEntrepreneursByNoteIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getEntrepreneursByNoteId(
      requestParameters: EntrepreneurResourceV2ApiGetEntrepreneursByNoteIdRequest,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<Array<Entrepreneur>> {
      return localVarFp
        .getEntrepreneursByNoteId(requestParameters.noteId, options)
        .then(request => request(axios, basePath))
    }
  }
}

/**
 * Request parameters for getEntrepreneursByNoteId operation in EntrepreneurResourceV2Api.
 */
export interface EntrepreneurResourceV2ApiGetEntrepreneursByNoteIdRequest {
  readonly noteId: string
}

/**
 * EntrepreneurResourceV2Api - object-oriented interface
 */
export class EntrepreneurResourceV2Api extends BaseAPI {
  /**
   *
   * @summary Get entrepreneurs by note id
   * @param {EntrepreneurResourceV2ApiGetEntrepreneursByNoteIdRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public getEntrepreneursByNoteId(
    requestParameters: EntrepreneurResourceV2ApiGetEntrepreneursByNoteIdRequest,
    options?: RawAxiosRequestConfig
  ) {
    return EntrepreneurResourceV2ApiFp(this.configuration)
      .getEntrepreneursByNoteId(requestParameters.noteId, options)
      .then(request => request(this.axios, this.basePath))
  }
}
